import script from "./MenuCollect.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuCollect.vue?vue&type=script&setup=true&lang=js"

import "./MenuCollect.vue?vue&type=style&index=0&id=72ebb551&lang=scss&scoped=true"

import exportComponent from "/data/devops/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72ebb551"]])

export default __exports__